import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type { ColorScheme }

const tokens = {
  dark: {
    bg: 'bg.callout',
    textPrimary: 'text.primary',
    borderLeftColor: 'brand.primary',
  },
  light: {
    bg: 'duskBlue.50',
    textPrimary: 'light.text.primary',
    borderLeftColor: 'light.brand.primary',
  },
} as const

// signalYellow.400 left border is a brand accent — same in both modes.
export const infoBoxStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  bg: tokens[colorScheme].bg,
  borderLeft: '1px solid',
  borderLeftColor: tokens[colorScheme].borderLeftColor,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  p: '16px',
  w: 'full',
})

export const infoBoxLabelStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  color: tokens[colorScheme].textPrimary,
  textStyle: 'small-accent',
  textTransform: 'uppercase',
  w: 'full',
})

export const infoBoxValueStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  color: tokens[colorScheme].textPrimary,
  textStyle: 'body',
  w: 'full',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
})
